/* eslint-disable no-undefined */
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { PaginationResponse } from '@wilson/base';
import { ConfigOptions, ConfigService } from '@wilson/config';
import {
  CirculationGroup,
  CirculationGroupWithShiftAndStay,
} from '@wilson/interfaces';
import { EMPTY, Observable } from 'rxjs';

export interface SearchItemsParams {
  search?: string;
  page?: number;
  limit?: number;
}

@Injectable({
  providedIn: 'root',
})
export class CirculationGroupGateway {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject<ConfigOptions>(ConfigService);

  searchItems(
    params?: SearchItemsParams,
  ): Observable<PaginationResponse<CirculationGroup>> {
    let queryParams = new HttpParams();

    if (params?.search) {
      queryParams = queryParams.set('search', params.search);
    }
    if (params?.page !== undefined) {
      queryParams = queryParams.set('page', params.page.toString());
    }
    if (params?.limit !== undefined) {
      queryParams = queryParams.set('limit', params.limit.toString());
    }

    return this.httpClient.get<PaginationResponse<CirculationGroup>>(
      `${this.config.host}/circulation-groups/search-items`,
      { params: queryParams },
    );
  }

  getItems(item: string): Observable<CirculationGroupWithShiftAndStay[]> {
    return this.httpClient.get<CirculationGroupWithShiftAndStay[]>(
      `${this.config.host}/circulation-groups/by-item/${item}`,
    );
  }

  createGroup(
    shiftIds: string[],
    stayIds: string[],
  ): Observable<CirculationGroupWithShiftAndStay[]> {
    return this.httpClient.post<CirculationGroupWithShiftAndStay[]>(
      `${this.config.host}/circulation-groups`,
      { shiftIds, stayIds },
    );
  }

  addItemToGroup(
    groupId: string,
    shiftId?: string,
    stayId?: string,
  ): Observable<CirculationGroupWithShiftAndStay[]> {
    if (shiftId || stayId) {
      return this.httpClient.patch<CirculationGroupWithShiftAndStay[]>(
        `${this.config.host}/circulation-groups/${groupId}`,
        { shiftId, stayId },
      );
    }
    return EMPTY;
  }

  mergeGroups(
    targetGroupId: string,
    sourceGroupId: string,
  ): Observable<CirculationGroupWithShiftAndStay[]> {
    return this.httpClient.post<CirculationGroupWithShiftAndStay[]>(
      `${this.config.host}/circulation-groups/${targetGroupId}/merge`,
      { sourceGroupId },
    );
  }

  removeItemsFromGroup(
    groupId: string,
    shiftIds: string[],
    stayIds: string[],
  ): Observable<CirculationGroupWithShiftAndStay[]> {
    return this.httpClient.delete<CirculationGroupWithShiftAndStay[]>(
      `${this.config.host}/circulation-groups/${groupId}/items`,
      { body: { shiftIds, stayIds } },
    );
  }
}
